/** represents any typed array, or plain array of numbers */
export type NumArray =
    TypedArray
    | Array<number>;

/** represents any typed array, float or int */
export type TypedArray =
    IntArray
    | FloatArray;

/** represents any int array, signed or not */
export type IntArray =
    UintArray
    | SintArray;

/** represents any signed int array, any size */
export type SintArray =
    Int8Array
    | Int16Array
    | Int32Array;

/** represents any unsigned int array, any size */
export type UintArray =
    Uint8Array
    | Uint16Array
    | Uint32Array;

/** represents any float array, any size */
export type FloatArray =
    | Float32Array
    | Float64Array;

/** Reads N bytes of given size starting from offset with given endianness.
 * This function is bounds checked.
 *
 * Reminder: in big endian, the largest numbers go first. Otherwise, they go last.
 */
export function read_number(xs: NumArray, n: number, byte_size: 8 | 16 | 32 | 64, offset: number, big_endian: boolean): number | Error {
    if (xs.length < offset + n)
        return new Error('read out of bounds');
    const base = 2 ** byte_size;
    let sum = 0;
    if (big_endian)
        for (let i = 0; i < n; i++)
            sum += xs[offset+i]! * base ** (n - 1 - i);
    else
        for (let i = n - 1; i >= 0; i--)
            sum += xs[offset+i]! * base ** i;
    return sum;
}
